import { CardEntity } from '../cards/types'

export const initialState = []

export type InitialStateType = CardEntity[]

interface ActionType {
  type: string,
  payload: any
}

export const modalsReducer = (state: InitialStateType = initialState, action: ActionType) => {
  switch(action.type) {
    case 'ADD_MODAL':
      return state.concat(action.payload)
    case 'RESET_MODAL':
      return []
    default:
      return state
  }
}